import { Col,  Row } from "reactstrap";
import { H3, H4, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { ProductDescription } from "../../../Constant";

const InvoiceDescription = () => {
  return (
      <Row>
        <Col md="4">
          <div className="invo-profile-left">
            <div className="d-flex">
              <div className="media-left">
                <Image className= "media-object rounded-circle img-60" src={dynamicImage("user/1.jpg")}  alt= "user"/>
              </div>
              <div className="flex-grow-1 m-l-20">
                <H3 className= "media-heading">Johan Deo</H3>
                <P>JohanDeo@gmail.com<br/>
                  <span>555-555-5555</span>
                </P>
              </div>
            </div>
          </div>
        </Col>
        <Col xl="8">
          <div className="text-md-end">
            <div id="project">
              <H4>{ProductDescription}</H4>
              <P>You're Only As Good As Your Last Collection, Which Is An Enormous Pressure. Jeans Represent Democracy In Fashion.Fashion Is About Dressing According To What's Fashionable.</P>
            </div>
          </div>
        </Col>
      </Row>
  );
};
export default InvoiceDescription;
